var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-field',[_c('label',[_vm._v(" "+_vm._s(_vm.$t("search"))+" ")]),_c('md-input',{ref:"user-search-input",model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }